import Cookies from 'js-cookie';
export var removeCookie = function (key) {
    Cookies.remove(key, { path: "/", domain: getCookieDomain() });
};
export var getCookieDomain = function () {
    var domainParts = window.location.hostname.split('.').slice(-2);
    return domainParts.join('.');
};
export var getMaintenanceBannerKey = function (application) {
    return "".concat(application, "-maintenance-banner");
};
//# sourceMappingURL=utils.js.map